import { RootState } from ".."
import { PayloadAction, createSlice } from "@reduxjs/toolkit"

interface IFeatures {
  isPersonalDailyDealEnabled: boolean
}

export const initialState: IFeatures = {
  isPersonalDailyDealEnabled: false
}

export const FeaturesSlice = createSlice({
  name: "features",
  initialState,
  reducers: {
    setPersonalDailyDealEnabled: (
      state,
      { payload }: PayloadAction<IFeatures["isPersonalDailyDealEnabled"]>
    ) => {
      state.isPersonalDailyDealEnabled = payload
    }
  }
})

const selectIsPersonalDailyDealEnabled = () => (state: RootState) => {
  return state.features.isPersonalDailyDealEnabled
}

export const FeaturesSelectors = {
  selectIsPersonalDailyDealEnabled
}

export const { setPersonalDailyDealEnabled } = FeaturesSlice.actions
